export function parseLocalDate(value?: string): Date | undefined {
  if (!value) return undefined
  const [yearText, monthText, dayText] = value.split('-')
  if (!yearText || !monthText || !dayText) return undefined
  const year = Number(yearText)
  const month = Number(monthText)
  const day = Number(dayText)
  const date = new Date(year, month - 1, day)
  return Number.isNaN(date.valueOf()) ? undefined : date
}

export function formatLocalDate(date: Date): string {
  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')
  return `${year}-${month}-${day}`
}

export function displayLocalDate(value: string): string {
  const date = parseLocalDate(value)
  return date
    ? new Intl.DateTimeFormat(undefined, {
        month: 'short',
        day: 'numeric',
        year: 'numeric',
      }).format(date)
    : value
}
